import React, { useEffect, useState } from "react";
import "./Header.css";
import { Avatar, IconButton, Menu, MenuItem, Tooltip, Typography } from "@mui/material";
import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import MenuOpenRoundedIcon from "@mui/icons-material/MenuOpenRounded";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import NotificationsNoneRoundedIcon from "@mui/icons-material/NotificationsNoneRounded";
import { auth } from "../firebase";
import { useNavigate } from "react-router-dom";

const navItems = [["Dashboard", DashboardRoundedIcon], ["Create New Form", DescriptionOutlinedIcon], ["Responses", AssignmentOutlinedIcon]];

export function DashboardSidebar({ activePage = "Dashboard" }) {
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  useEffect(() => {
    document.body.classList.toggle("sidebar-collapsed", collapsed);
    return () => document.body.classList.remove("sidebar-collapsed");
  }, [collapsed]);

  return <aside className={`dashboard-sidebar ${collapsed ? "is-collapsed" : ""}`}>
    <Tooltip title={collapsed ? "Expand navigation" : "Collapse navigation"} placement="right">
      <button className="sidebar-toggle" type="button" onClick={() => setCollapsed((value) => !value)} aria-label={collapsed ? "Expand navigation" : "Collapse navigation"}>
        {collapsed ? <MenuRoundedIcon fontSize="small" /> : <MenuOpenRoundedIcon fontSize="small" />}
      </button>
    </Tooltip>
    <div className="brand-mark"><span>SUREWAY</span><small>by OmneVu.com</small></div>
    <nav className="side-navigation" aria-label="Primary navigation">
      {navItems.map(([label, Icon]) => {
        const routes = {
          Dashboard: "/",
          "Create New Form": "/create-form",
          Responses: "/responses",
        };
        const handleClick = () => navigate(routes[label]);
        return (
          <Tooltip title={collapsed ? label : ""} placement="right" key={label}>
            <button
              className={`nav-item ${activePage === label ? "active" : ""}`}
              type="button"
              onClick={handleClick}
            >
              <Icon fontSize="small" />
              <span>{label}</span>
            </button>
          </Tooltip>
        );
      })}
    </nav>
  </aside>;
}

function Header({ photoURL, value }) {
  const [anchorElUser, setAnchorElUser] = useState(null);
  const logout = async () => { try { await auth.signOut(); sessionStorage.clear(); setAnchorElUser(null); window.location.href = "/signin"; } catch (error) { console.error("Error signing out:", error); } };
  return <>
    <DashboardSidebar />
    <header className="header">
      <div><h1>Welcome back!</h1><p>Create, manage and analyze your forms with ease.</p></div>
      <div className="header_right">
        <IconButton className="notification-button" aria-label="Notifications"><NotificationsNoneRoundedIcon /></IconButton>
        <Tooltip title="Open account menu"><IconButton onClick={(event) => setAnchorElUser(event.currentTarget)} sx={{ p: 0 }}>{photoURL ? <Avatar src={photoURL} alt={value || "Account"} /> : <Avatar className="account-avatar">A</Avatar>}</IconButton></Tooltip>
        <Menu anchorEl={anchorElUser} open={Boolean(anchorElUser)} onClose={() => setAnchorElUser(null)}><MenuItem onClick={logout}><Typography>Logout</Typography></MenuItem></Menu>
      </div>
    </header>
  </>;
}
export default Header;
